export default "__VITE_ASSET__BzxkwghA__"